import React from 'react';

import { FormattedMessage } from '../../../../i18n';
import { Site } from '../../lib/Site';
import NavigationItem from '../NavigationItem/NavigationItem';

interface Props {
    site: Site;
}

export default function SupportMenu({ site }: Props) {
    const officeHours = site.get('phone.office_hours');

    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={
                            <div>
                                <FormattedMessage
                                    message="{phone}"
                                    values={{ phone: site.get('phone.support') }}
                                />
                                {officeHours && (
                                    <div>
                                        <small className="subtle-text">{officeHours}</small>
                                    </div>
                                )}
                            </div>
                        }
                        url="/help"
                        icon="phone-1"
                    />
                    <NavigationItem
                        label={__('Design consultation')}
                        url="/design-consultation"
                        icon="consultation-1"
                    />
                </ul>
                <ul className="menu__item menu__item--action-list menu__item--separated">
                    <NavigationItem
                        label={__('Help Center')}
                        url="/help"
                        icon="question-mark-1"
                        linkAttributes={{ target: '_blank' }}
                    />
                </ul>
            </div>
        </div>
    );
}
